import React from 'react';
import { ProfileWhatsAppAccountCreateWidget } from './widget';

export const ProfileWhatsAppAccountCreatePage: React.FC = () => <ProfileWhatsAppAccountCreateWidget />;
